import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { UrlRoot } from "src/app/models/url-root.enum";
import { UrlPages } from "src/app/models/url-pages.enum";
import { ApplicationService } from "./application.service";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { ApiService } from "./api.service";
import { ServerTypes } from "src/app/models/servers";
import { ToastrService } from "ngx-toastr";


@Injectable()
export class NavigateService {
  constructor(public router: Router, public applicationService: ApplicationService, private toastrService: ToastrService, private http: HttpClient, private apiService: ApiService) {}
  
  public navigateToPage(page:string, id: string, type: string, newWindow: boolean = false): void {
    const resource = this.applicationService.getPage(page, type);

    console.log("resource",resource);

    if (newWindow) 
      window.open(`${resource.url}/${id}`, "_blank", "width=1740,height=920,resizable,scrollbars=yes,status=1");

    // this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
    //   this.router.navigate([`${resource.url}/${id}`]);
    // });

     this.router.navigate([`${resource.url}/${id}`]);
  }

  public navigateToClaim(claim: any): void {
    this.navigateToPage('claim', claim.claimId, `CLAIMTYPEID-${claim.claimTypeId}`)
  }

  public navigateToInvoice1(invoiceId: string, newWindow: boolean = false): void {
    console.log('Navigating to claim with type:', newWindow);
    if (newWindow) window.open("https://bo.epass24.com/claims/invoice/" + invoiceId, "_blank", "width=1740,height=920,resizable,scrollbars=yes,status=1");
    else this.router.navigate(["kmt/penalty/" + invoiceId]);
  }

  public navigateToInvoice(invoice: any, newWindow: boolean = false): void {

    this.navigateToPage('invoice', invoice.invoiceId, `INVOICETYPEID-${invoice.invoiceTypeId}`, newWindow)

  }

  // public navigateToInvoice(invoiceId: string, newWindow: boolean = false): void {
  //   if (newWindow) window.open("https://bo.epass24.com/claims/invoice/" + invoiceId, "_blank", "width=1740,height=920,resizable,scrollbars=yes,status=1");
  //   else this.router.navigate(["claims/invoice/" + invoiceId]);
  // }

  public reloadCurrentRoute() {
    let currentUrl = this.router.url;
    this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }

  public navigateToEntity(entityId: string, newWindow: boolean = false): void {
    if (newWindow) window.open("https://bo.epass24.com/claims/entity/" + entityId, "_blank", "width=1740,height=920,resizable,scrollbars=yes,status=1");
    else this.router.navigate(["claims/entity/" + entityId]);
  }

  public navigateToReport(reportId: string): void {
    this.router.navigate([UrlRoot.claims + "/" + UrlPages.report + "/" + reportId]);
  }

  public navigateToPayment(paymentUID: string): void {
    this.router.navigate(["wallets/payment/" + paymentUID]);
  }
  public navigateToPaymentByTransactionId(transactionId: string): void {
    this.router.navigate(["wallets/payment/transaction/" + transactionId]);
  }

  public navigateToVehicle(vehicleId: string): void {
    this.router.navigate([UrlRoot.claims + "/" + UrlPages.vehicle + "/" + vehicleId]);
  }
  public navigateToVehicleInvoices(vehicleId: string): void {
    this.router.navigate(["mz/vehicle/" + vehicleId + "/invoices"]);
  }

  public navigateToReceiptOnWebsite(paymentId: string): void {
    const url = "https://www.epass24.com/en/pay/receipt/";

    window.open(url + paymentId, "_blank", "width=900,height=820,resizable,scrollbars=yes,status=1");
  }
  public navigateToAdyen(pspReference: string): void {
    window.open(
      "https://ca-live.adyen.com/ca/ca/accounts/showTx.shtml?txType=Payment&pspReference=" + pspReference,
      "_blank",
      "width=1280,height=1024,resizable,scrollbars=yes,status=1"
    );
  }

  public navigateToAccount(accountId: string): void {
    this.router.navigate(["wallets", "externalaccount", accountId]);
  }

  public navigateToBankTransaction(transactionId: string, popup: boolean = false): void {
    if (popup) {
      this.popupTarget("wallets", "banktransaction", transactionId);
    } else {
      this.router.navigate(["wallets", "banktransaction", transactionId]);
    }
  }

  public navigateToTransaction(accountId: string, year: string, month: string): void {
    const dateEnd: any = new Date(+year, +month, 0);
    this.router.navigate([UrlRoot.users, UrlPages.user, accountId, "transactions"], {
      queryParams: {
        fromdate: `${year}-${month}-01`,
        todate: `${year}-${month}-${dateEnd.getDate()}`,
      },
    });
  }
  public navigateToMessage(messageId: string): void {
    this.router.navigateByUrl("esb/messages?messageid=" + messageId);
  }
  public navigateToUser(userId: string): void {
    this.router.navigate(["users", "user", userId]);
  }

  public navigateToAdminUser(userId: string): void {
    this.router.navigate(["admin", "user", userId]);
  }

  public navigateToMzDecision(claimId: string): void {
    this.router.navigate(["mz", "decision", claimId]);
  }

  public navigateToListsClaimsList(year: string, month: string): void {
    this.router.navigate(["lists", "claims", "list", year, month]);
  }

  public navigateToTask(taskId: string) {
    this.router.navigate(["esb", "task", taskId]);
  }

  public navigateToMzPending(value1: string) {
    this.router.navigate(["mz/mzpending"], {
      queryParams: { claim: String(9) },
    });
  }

  public navigateToMzDecisionsPending(type: string) {
    this.router.navigate(["mz/decisions/pending"], {
      queryParams: { claim: String(9), hold: false },
    });
  }

  public navigateToSearchResults(id: string) {
    this.router.navigate(["search/results"], { queryParams: { query: id } });
  }

  public navigateToRoute(...routeParams: string[]) {
    const url = routeParams.join("/").replace("/?", "?").replace("=/", "=");
    this.router.navigateByUrl(url);
  }

  public navigateToRouteInNewWindow(...target: string[]) {
    const url = this.router.serializeUrl(this.router.createUrlTree(target));
    window.open(url, "_blank");
  }

   public navigateToRouteInTab2(...target: string[]) {
    const url = this.router.serializeUrl(this.router.createUrlTree(target));
    window.open(url, "tab2");
  }


  public openUrlNewWindow(url: string) {   
    window.open(url, "_blank");
  }

  public popupTarget(...target: string[]) {
    const url = this.router.serializeUrl(this.router.createUrlTree(target));
    window.open(url, "_blank");
  }

  /**
   * Fetches a PDF and opens it in a popup window.
   * `target` is joined with "/" into a URL. A relative path (no scheme) is
   * resolved against the currently configured ptdesk server, so page
   * definitions don't need to hardcode the host.
   */
  public openPDF(...target: string[]) {
    NProgress.start();
    const url = this.resolvePdfUrl(target);
    this.http.get(url, { responseType: 'blob' })
    .subscribe((document) => {
      const file = new Blob([document], {
        type: 'application/pdf',
      });
      const link = URL.createObjectURL(file);
      window.open(link, '_blank', "width=1280,height=1024,resizable,scrollbars=yes,status=1");
      NProgress.done();
    }, (error: HttpErrorResponse) => {

      const message = this.blobToString(error.error);
      this.toastrService.error(message);
      NProgress.done();
    })    
  }
  private resolvePdfUrl(target: string[]): string {
    const path = target
      .map((part) => (part ?? "").trim())
      .filter((part) => part.length > 0)
      .join("/")
      .replace("/?", "?")
      .replace("=/", "=");

    if (/^https?:\/\//i.test(path)) return path;

    const server = this.apiService.getCurentServer(ServerTypes.ptdesk);
    return `${server}/${path.replace(/^\/+/, "")}`;
  }

  private blobToString(blob): string {
    const url = URL.createObjectURL(blob);
    const xmlRequest = new XMLHttpRequest();
    xmlRequest.open('GET', url, false);
    xmlRequest.send();
    URL.revokeObjectURL(url);
    return xmlRequest.responseText;
}
}
